<h3 style="text-align: center;">Projects</h3>
<!-- CR Projects App -->
<div class="container-fluid">

  <!-- CR Project Details -->

  <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">
    <!-- JJM -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/jjm/">
          <p style="font-size: medium;">JJM</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- Flame University -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/flame/">
          <p style="font-size: medium;">Flame</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- Unity Green -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/survey/">
          <p style="font-size: medium;">Unity Green</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    
    <!-- GeoVisualizer Beta-->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/beta/geovisualizer/">
          <p style="font-size: medium;">GeoVisualizer Beta</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

  </div>
  <!-- end Demo Product Details -->

</div>


<h3 style="text-align: center;">Products</h3>
<!-- CR Produts App -->
<div class="container-fluid">
  <!-- CR Produts Details -->

  <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">
    <!-- GeoFlow Manager -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/geoflow/">
          <p style="font-size: medium;">GeoFlow Manager</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- GeoFlow WCD -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/wcd/">
          <p style="font-size: medium;">GeoFlow Manager for WCD</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- GeoScanner -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/geoscanner/">
          <p style="font-size: medium;">GeoScanner Reviewer</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

  </div>

</div>

<div class="container-fluid">
  <!-- CR Produts Details -->
  <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">
    <!-- GeoSet Viewer -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/geoset/">
          <p style="font-size: medium;">GeoSet Viewer</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    <!-- GeoVisualizer -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-3">
        <span></span>
        <a class="card" target="_blank" rel="noopener" href="https://products.coderize.in/geovisualizer/">
          <p style="font-size: medium;">GeoVisualizer</p>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>

    

    


  </div>
</div>




<h3 style="text-align: center;">Mobile App Apk's</h3>
<!-- <p >Here are some links to help you get started with Live Projects:</p> -->
<!-- beta App -->
<div class="container-fluid">

  <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">


    <!-- CR Project Apk -->

    <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">
      <div>
        <h6 style="font: bold; text-align: center; padding-right: 30px;">Project</h6>
        <div class="col-sm-4">
          <a class="card" target="_blank" rel="noopener" (click)="unity()">
            <span>Unity Green</span>
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </a>
        </div>

      </div>

      <div>
        <h6 style="font: bold; text-align: center; padding-right: 30px;">Products</h6>

        <!-- GeoFlow -->
        <div class="col-sm-4">
          <a class="card" target="_blank" rel="noopener" (click)="geoflow()">
            <span>GeoFlow Creator</span>
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </a>
        </div>

        <!-- GeoScanner -->
        <div class="col-sm-4">
          <a class="card" target="_blank" rel="noopener" (click)="geoscanner()">
            <span>GeoScanner</span>
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </a>
        </div>

        <!-- GeoSet -->
        <div class="col-sm-4">
          <a class="card" target="_blank" rel="noopener" (click)="geoset()">
            <span>GeoSet Creator</span>
            <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
            </svg>
          </a>
        </div>
      </div>

    </div>

  </div>

</div>
<!-- </div> -->


<h3 style="text-align: center;">Documents</h3>
<div class="container-fluid">
  <div class="row" style="background-color:rgba(238, 230, 230, 0.904);">
    <!-- CR Profile -->
    <div>
      <h6 style="font: bold; text-align: center;"></h6>
      <div class="col-sm-4">
        <a class="card" target="_blank" rel="noopener" (click)="crProfile()">
          <span>CR Profile</span>
          <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </a>
      </div>
    </div>
  </div>

</div>